import React from 'react';
import HistoryIcon from '@mui/icons-material/History';
import { useHandHistory } from 'hooks/useHandHistory';
import { useTableSelector } from 'hooks/useTableSelector';

import styles from './HandHistory.module.scss';

export const HandHistoryTrigger = () => {
  const { isOpen, setIsOpen, data } = useHandHistory();
  // Mirrors the footer button: only an observer who has not sat down cannot
  // open it. A seated player before their first hand opens it to the panel's
  // "where your history starts" guidance (same predicate as HandHistoryPanel).
  const isSeated = useTableSelector((table) => Boolean(table.currentPlayer?.isSeated));
  const locked = Boolean(data?.locked) && !isSeated;

  return (
    <button
      className={styles.trigger}
      type='button'
      aria-pressed={isOpen}
      disabled={locked && !isOpen}
      title={locked ? 'Hand History unlocks when you sit down' : 'Hand History'}
      onClick={() => setIsOpen((current) => !current)}>
      <HistoryIcon />
      <span>Hand History</span>
    </button>
  );
};
